import type { SVGProps } from "react"
import React from "react"

export const TwitterColor: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      d="M7.53321 19.7143C4.76035 19.7143 2.17558 18.9078 0 17.5162C1.84714 17.6358 5.10692 17.3495 7.1345 15.4155C4.08435 15.2756 2.7088 12.9362 2.52938 11.9365C2.78854 12.0365 4.02454 12.1565 4.72229 11.8766C1.21363 10.9968 0.675367 7.91771 0.79498 6.97798C1.45285 7.43784 2.56925 7.5978 3.00783 7.55781C-0.261606 5.21849 0.914594 1.69951 1.49273 0.939728C3.83899 4.19028 7.35532 6.01592 11.7055 6.11746C11.6234 5.75773 11.5801 5.38322 11.5801 4.99855C11.5801 2.23793 13.8115 0 16.564 0C18.0022 0 19.2981 0.610932 20.2077 1.58815C21.1688 1.36295 22.6151 0.835772 23.3222 0.37989C22.9658 1.65952 21.8562 2.72699 21.1851 3.12264C21.1796 3.10912 21.1906 3.1361 21.1851 3.12264C21.7746 3.03346 23.3698 2.72689 24 2.29933C23.6884 3.01821 22.512 4.21348 21.5466 4.88265C21.7262 12.804 15.6656 19.7143 7.53321 19.7143Z"
      fill="#47ACDF"
    />
  </svg>
)
